import { ReactNode } from "react";

export interface INavbarCollapse {
  children?: ReactNode;
  className: string;
}
function NavbarCollapse({ children, className }: INavbarCollapse) {
  return <div className={className}>{children}</div>;
}

export default NavbarCollapse;
